export interface Configuration {
    [key: string]: string;
}